import styled from "styled-components";

export const Image = styled.img`
  height: 35px;
  ${({ theme }) => theme.smartphone} {
    height: 30px;
  }
`;
